<article class="merchant-details-container">
  <section class="side-menu">
    <app-merchants-side-menu></app-merchants-side-menu>
  </section>
  <section class="wrapper">
    <router-outlet></router-outlet>
  </section>
</article>
